import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#171f2e", // #azul oscuro
        secondary: "#9CABCF", // #azul raro
        accent: "#707788", // #gris oscuro
        accent2: "#205F95" //
      }
    }
  }
});

// Azul oscuro: 		#03123B
// Azul pastel izq:	#205F95
// Azul el que queda:  #006A9E
